enum PermitStatusType {
	Undefined = 0,
	Submitted = 1,
	UnderReview = 2,
	RequestMoreInformation = 3,
	Approved = 4,
	Rejected = 5,
	Active = 6,
	Cancelled = 7,
	AboutToExpire = 8,
	Expired = 9
}

export default PermitStatusType;
